import {
  BlockTableControl,
  BlockTableControlActions,
  BlockTableControlSearch,
} from "shared-web/components/composite/TableV2/BlockTableControl/BlockTableControl"
import { FilterGroup } from "shared-web/components/composite/TableV2/FilterGroup/FilterGroup"
import { Sort } from "shared-web/components/composite/TableV2/Sort/Sort"
import { Table } from "shared-web/components/composite/TableV2/Table"
import { TableScrollContainer } from "shared-web/components/composite/TableV2/TableScrollContainer"

import { classNames } from "lib/classNames"

import { useCreditsTable } from "./hooks/useCreditsTable"

export function CreditsTable() {
  const {
    tableProps,
    sortProps,
    filters,
    searchQuery,
    setSearchQuery,
    searchInputProps,
  } = useCreditsTable()

  return (
    <>
      <BlockTableControl
        searchInput={
          <BlockTableControlSearch
            searchQuery={searchQuery}
            onSearchQueryChange={setSearchQuery}
            autoFocus
            {...searchInputProps}
          />
        }
        actions={<BlockTableControlActions actions={[]} />}
        filters={<FilterGroup filters={filters} />}
        sort={<Sort {...sortProps} />}
        extendedStyle
      />
      <TableScrollContainer
        className={classNames("rounded-b-surface min-h-[55vh] overflow-auto")}
      >
        <Table {...tableProps} />
      </TableScrollContainer>
    </>
  )
}
